import { useTranslation } from 'react-i18next';

import { Flex } from 'antd';

import { ReactComponent as IconLogo } from 'assets/images/icon-logo.svg';

import { SLogoText, SSubtitle, SWrapper } from './style';

// Не reuse-имо views/components/Logo: він викликає useNavigate(), а цей
// хедер рендериться Authenticator-ом до автентифікації, поза Router-контекстом
// (див. router/Router.tsx — RouterProvider живе всередині <Authenticator>).
export const AuthHeader = () => {
  const { t } = useTranslation();

  return (
    <SWrapper vertical align="center" gap={8}>
      <Flex align="center" gap={8}>
        <IconLogo width={44} height={44} />
        <SLogoText>Svitlofour</SLogoText>
      </Flex>
      <SSubtitle>{t('adminCabinet')}</SSubtitle>
    </SWrapper>
  );
};
